<template>
    <div class="header">
        <div>
            <a href="https://www.91jf.com/" target="_blank"><img :src="logo" width="250px" class="pointer" alt="91家纺网-叠石桥网销导航"></a>
            <span class="title" v-if="$route.matched[0].path === '/register'">账户注册</span>
        </div>

        <div>
            <a-space align="center" :size="40">
            <div class="bar_item pointer" v-for="(item,index) in topMenu" :key="index" @click="handleUrl(item)">
                <a-tooltip placement="top" :title="item.tip">
                    <img :src="item.img" width="22px" height="22px">
                    {{item.name}}
                </a-tooltip>
            </div>
            </a-space>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginHeader',
    data () {
        return {
            topMenu: [
                /*{
                  name: '云仓直发',
                  url: 'https://detail.91jf.com/cloudhouse/index',
                  img: require('@/assets/images/login/brand_icon.png'),
                  target: '_blank'
                },
                {
                    name: '清仓频道',
                    url: 'https://detail.91jf.com/store/7qu4489',
                    img: require('@/assets/images/login/ic_qingcang.png'),
                    target: '_blank'
                },*/
                {
                    name: '保存到桌面',
                    url: 'https://detail.91jf.com/desktop',
                    img: require('@/assets/images/login/ic_save.png'),
                    // tip: '点击右键，选择“目标另存为...”，将此快捷方式保存到桌面即可',
                    target: '_self'
                }
            ],
          logo:'',
        }
    },
    created() {
      this.getLogo();
    },
    methods: {
        handleUrl ({ url, target }) {
            window.open(url, target)
        },
        toLogin () {
            this.$router.push('/login')
        },
        getLogo(){
          var _this = this;

          _this.$util.api('/logo',{},function(res){
            if(res.code == 10000 && res.data!=''){
              _this.logo = res.data
            }
          });
        }
    }
}
</script>

<style scoped>
.header {
    width: 90%;
    /* max-width: 1190px; */
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header .bar_item {
    font-size: 12px;
    color: rgb(78, 76, 76);
}

.header .bar_item:hover {
    color: #fd5902;
}
.header .title {
    display: inline-block;
    padding-left: 20px;
    font-size: 24px;
    height: 45px;
    line-height: 45px;
    border-left: 1px solid #d8d8d8;
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/LoginHeader.vue